import 'babel-polyfill';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

import VipCenter from '@webfront-components-vue/vue-vip-center';
import '@webfront-components-vue/vue-vip-center/dist/style.css';

// import VipCenter from '@webfront-components-vue/vue-vip-center-w-test';
// import '@webfront-components-vue/vue-vip-center-w-test/dist/style.css';

import dictWebsiteFooter from '@webfront-components-vue/dict-website-footer';
import '@webfront-components-vue/dict-website-footer/dist/style.css';
import 'uikibrary/dist/UIKibrary.css';
// eslint-disable-next-line import/no-extraneous-dependencies
import ElementPlus from 'element-plus';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'element-plus/dist/index.css';
import Lazyload from 'vue3-lazyload';
import App from './App.vue';
import router from './router';
import './styles/index.css';
import toastCom from './components/common/Toast/index';
import CPopUp from './components/common/CPopUp/index';
import './log/rlog.js';

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp(App);
app.config.globalProperties.$toast = toastCom;
window.$CPopup = CPopUp;

let timer = null;
if (process.env.VUE_APP_MODE === 'test') {
  timer = setInterval(() => {
    const startTime = performance.now();
    debugger;
    const endTime = performance.now();
    if (endTime - startTime > 100) {
      window.location.href = 'about:blank';
      clearInterval(timer);
      timer = null;
    }
  }, 100);
}

app
  .use(router)
  .use(pinia)
  .use(VipCenter)
  .use(dictWebsiteFooter)
  .use(ElementPlus)
  .use(Lazyload)
  .mount('#app');
